// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import "babel-polyfill";
import Vue from "vue";
import { createApp } from 'vue'
import store from '@/store'
import Loading from '@/components/internal/loader';
import { checkAuth } from "@/auth";

import * as monaco from "monaco-editor/esm/vs/editor/editor.api";
import "@/components/element/packages/theme-chalk/src/common/transition.scss";
import "@/components/element/packages/theme-chalk/src/select.scss";
import "@/components/element/packages/theme-chalk/src/input-number.scss";
import "@/components/element/packages/theme-chalk/src/input.scss";
import "@/components/element/packages/theme-chalk/src/checkbox.scss";
import "@/components/element/packages/theme-chalk/src/switch.scss";
import "@/components/element/packages/theme-chalk/src/button.scss";
import "@/components/element/packages/theme-chalk/src/icon.scss";
import "@/components/element/packages/theme-chalk/src/cascader.scss";
import "@/components/element/packages/theme-chalk/src/radio.scss";
import "@/components/element/packages/theme-chalk/src/radio-button.scss";
import "@/components/element/packages/theme-chalk/src/dialog.scss";
import "@/components/element/packages/theme-chalk/src/table.scss";
import "@/components/element/packages/theme-chalk/src/tabs.scss";
import "@/components/element/packages/theme-chalk/src/pagination.scss";
import "@/components/element/packages/theme-chalk/src/loading.scss";
import "@/components/element/packages/theme-chalk/src/notification.scss";
import "@/components/element/packages/theme-chalk/src/upload.scss";
import "@/components/element/packages/theme-chalk/src/drawer.scss";
import "@/components/element/packages/theme-chalk/src/tag.scss";
import "@/components/element/packages/theme-chalk/src/popover.scss";
import "@/components/element/packages/theme-chalk/src/popconfirm.scss";
import "@/components/element/packages/theme-chalk/src/dropdown.scss";
import "@/components/element/packages/theme-chalk/src/date-picker.scss";
import "@/components/element/packages/theme-chalk/src/alert.scss"

import "@/assets/styles/input.css";
import "@/assets/styles/button.css";
import "@/assets/styles/icon.css";
import "@/assets/styles/table.css";
import "@/assets/styles/color.css";
import "@/assets/styles/trash.css";
import "@/assets/fonts/vikingo.css";
import "@/assets/addons.css";
import "@/assets/styles/style.css";

import config from "@/config";
import logger from "@/logger.js";


// import VueHtml2Canvas from "vue-html2canvas";
//import VirtualScroller from "vue-virtual-scroller";

import App from "./App";
import router from "./router";
//import VueI18n from "vue-i18n";
import Elem from "@/components/element/src/index";

import lang from "@/components/element/src/locale/lang/en";
import locale from "@/components/element/src/locale";
import { loadSettings } from "@/utils.js";

if (config.desktop_mode) {
    console.log = logger;
    console.error = logger;
    console.warn = logger;
}

Vue.use(Elem);
// Vue.use(VueHtml2Canvas);
// Vue.use(VirtualScroller);
import VueVirtualScroller from 'vue-virtual-scroller'
import 'vue-virtual-scroller/dist/vue-virtual-scroller.css'
Vue.use(VueVirtualScroller)
Vue.component('RecycleScroller', VueVirtualScroller.RecycleScroller)


Vue.use(Loading);
locale.use(lang);
Vue.prototype.$forceCompute = function(
    computedName,
    forceUpdate /* default: true */
) {
    if (this._computedWatchers[computedName]) {
        this._computedWatchers[computedName].run();
        if (forceUpdate || typeof forceUpdate == "undefined") this.$forceUpdate();
    }
};

//Vue.use(VueI18n);
// Vue.use(Antd);

import VueSocketIO from "vue-socket.io";
var wsProto = "ws:";
if (location.protocol == "https:") {
    wsProto = "wss:";
}

if (!config.desktop_mode) {
    Vue.use(
        new VueSocketIO({
            debug: true,
            connection: wsProto +
                "//" +
                location.hostname +
                (location.port ? ":" + location.port : "") // http://127.0.0.1:1337
        })
    );
}

Vue.config.lang = "en-US";
Vue.config.productionTip = false;


import "./ace-helpers.js";

/* eslint-disable no-new */
if (config.desktop_mode) {
    new Vue({
        store,
        el: "#app",
        router,
        components: { App },
        template: "<App/>"
    });
} else {
    /* eslint-disable no-new */
    checkAuth().then(result => {
        new Vue({
            store,
            el: "#app",
            router,
            components: { App },
            template: "<App/>"
        });
        loadSettings();
    });


    // new Vue({
    //     store,
    //     el: "#app",
    //     router,
    //     components: { App },
    //     template: "<App/>"
    // });
}


// WEBPACK FOOTER //
// ./src/main.js